import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=f0ad2456&scoped=true"
import script from "./Import.vue?vue&type=script&lang=ts"
export * from "./Import.vue?vue&type=script&lang=ts"
import style0 from "./Import.vue?vue&type=style&index=0&id=f0ad2456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ad2456",
  null
  
)

export default component.exports